import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import axios from "axios";
import { api } from "../../maps/data";

const AntiThievesPage = () => {
  const { siteId } = { siteId: "66f11d80c8adb8d1ed21ae0e" };
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const videoRefs = useRef([]);

  const fetchData = async () => {
    try {
      const response = await api({
        type: "getTempCarts",
        data: { siteId },
        disableBI: true,
        disableEH: true,
      });
      setData(response);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 3000); // Fetch data every 3 seconds
    return () => clearInterval(interval); // Cleanup interval on component unmount
  }, [siteId]);

  useEffect(() => {
    videoRefs.current.forEach((video) => {
      if (video) {
        video.play().catch((error) => {
          console.error("Error attempting to play", error);
        });
      }
    });
  }, [data]);

  if (loading) return <Container>Loading...</Container>;
  if (error) return <Container>Error: {error}</Container>;

  return (
    <Container>
      <Header>Anti-Theft Monitoring</Header>
      {data.map((shopper) => (
        <ShopperCard key={shopper._id} bgColor={shopper.color}>
          <ShopperInfo>
            <ColorCircle bgColor={shopper.color} />
            <ShopperId>Shopper ID: {shopper.shopperId}</ShopperId>
          </ShopperInfo>
          {shopper.products.length > 0 ? (
            shopper.products.map((product) => (
              <ProductCard key={product._id}>
                <ProductName>{product.productName}</ProductName>
                <ProductImage
                  src={product.imageUrl}
                  alt={product.productName}
                />
                <ProductInfo>
                  <ProductTimestamp>
                    Added At: {new Date(product.createdAt).toLocaleString()}
                  </ProductTimestamp>
                  <ProductStatus>Status: {product.status}</ProductStatus>
                </ProductInfo>
                <VideoSection>
                  {product.videoUrls.map((video, index) => (
                    <VideoBox
                      key={index}
                      ref={(el) => (videoRefs.current[index] = el)}
                      controls
                      loop
                      muted
                    >
                      <source
                        src={video.camerasData[0].play}
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </VideoBox>
                  ))}
                </VideoSection>
              </ProductCard>
            ))
          ) : (
            <NoProductsMessage>
              No products added by this shopper.
            </NoProductsMessage>
          )}
        </ShopperCard>
      ))}
    </Container>
  );
};

const Container = styled.div`
  padding: 10px;
  font-family: "Helvetica Neue", sans-serif;
  background-color: #f4f4f9;
  color: #333;
  min-height: 100vh;
  overflow: hidden;
`;

const Header = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 10px;
  color: #333;
  text-align: center;
`;

const ShopperCard = styled.div`
  background-color: #ffffff;
  border-radius: 15px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  padding: 8px;
`;

const ShopperInfo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

const ColorCircle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: ${(props) => props.bgColor};
  margin-right: 10px;
`;

const ShopperId = styled.p`
  font-size: 1.75rem;
  font-weight: bold;
  color: #333;
`;

const ProductCard = styled.div`
  display: flex;
  align-items: center;
  background-color: #f9f9f9;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const ProductName = styled.h3`
  font-size: 1.5rem;
  font-weight: bold;
  color: #333;
  margin-right: 0px;
  width: 240px;
  margin-right: 20px;
`;

const ProductImage = styled.img`
  height: 160px;
  border-radius: 10px;
  margin-right: 20px;
`;

const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 8px;
`;

const ProductTimestamp = styled.p`
  font-size: 1rem;
  color: #777;
`;

const ProductStatus = styled.p`
  font-size: 1rem;
  color: #555;
`;

const VideoSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`;

const VideoBox = styled.video`
  height: 200px;
  width: 300px;
  border-radius: 10px;
  background-color: #ddd;
  margin: 10px;
`;

const NoProductsMessage = styled.p`
  text-align: center;
  font-style: italic;
  color: #777;
  font-size: 1.5rem;
`;

export default AntiThievesPage;
